var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-bar",style:(_vm.formatStyle())},[_c('div',{class:`inner-fill ${_vm.progressClass}`,style:(`width: ${_vm.progressPercent}%; ${_vm.formatStyle()}`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }